module.exports = "\nhtml[lang=\"en-US\"][data-device-type=\"dedicated\"] {\n    min-width: 100%;\n    height:100%;\n}\n\n.containerCentered {\n    box-sizing: border-box;\n    width: 100%;\n    display: block;\n    min-width: 100%;\n    max-width: 100%;\n\n}\n.containerCentered .print_inner {\n    display: none;\n}\n.containerMobileFullWidth .row-fluid:nth-child(2) .containerCentered .large {\n    display: none;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./src/types/credit/Terms.cssraw
 ** module id = 812
 ** module chunks = 0
 **/